<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch17"></a><a id="page_18"></a><a href="#/contents#ch17"><b>Under the Sea</b></a></h2>
<p class="noindent"><span>Bottlenose dolphins don’t sleep at all until they’re one month old. And when they do nap, they always keep one eye open.</span></p>
<p class="noindent"><span>The blue whale’s tongue weighs as much as an adult female brown bear.</span></p>
<p class="noindent"><span>Sea otters sometimes tie themselves together with kelp to avoid being separated while they sleep.</span></p>
<p class="noindent"><span>Humans are responsible for the deaths of as many as 73 million sharks every year.</span></p>
<p class="noindent"><span>Sea slugs can have as many as 25,000 teeth.</span></p>
<p class="noindent"><span>Dolphins can recognize themselves in a mirror.</span></p>
<p class="noindent"><span>There are at least 34 shark species in the Gulf of Mexico.</span></p>
<p class="noindent"><span>Orcas (killer whales) live in every ocean on Earth.</span></p>
<p class="noindent"><span>Mudskippers are fish that live in tide pools and can breathe through their skin. As long as they stay moist, they can climb out of the ocean and walk around on land.</span></p>
<p class="noindent"><span>Found in a shark’s belly in 1941: 3 belts, 9 shoes, 14 stockings, and 43 buttons.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter17.vue?4b6b031b